export const DayOfWeek = {
  MONDAY: 'Monday',
  TUESDAY: 'Tuesday',
  WEDNESDAY: 'Wednesday',
  THURSDAY: 'Thursday',
  FRIDAY: 'Friday',
  SATURDAY: 'Saturday',
  SUNDAY: 'Sunday',
  PUBLIC_HOLIDAYS: 'PublicHolidays',
};
export type DayOfWeek = (typeof DayOfWeek)[keyof typeof DayOfWeek];

export const Week = [
  DayOfWeek.SUNDAY,
  DayOfWeek.MONDAY,
  DayOfWeek.TUESDAY,
  DayOfWeek.WEDNESDAY,
  DayOfWeek.THURSDAY,
  DayOfWeek.FRIDAY,
  DayOfWeek.SATURDAY,
];
export const WeekWithHoliday = [
  DayOfWeek.SUNDAY,
  DayOfWeek.MONDAY,
  DayOfWeek.TUESDAY,
  DayOfWeek.WEDNESDAY,
  DayOfWeek.THURSDAY,
  DayOfWeek.FRIDAY,
  DayOfWeek.SATURDAY,
  DayOfWeek.PUBLIC_HOLIDAYS,
];

// NOTE: this doesn't appear to be used anywhere
export function DayOfWeekAware(constructor: () => void): void {
  constructor.prototype.DayOfWeek = DayOfWeek;
  constructor.prototype.Week = Week;
  constructor.prototype.WeekWithHoliday = WeekWithHoliday;
}

export interface Span {
  dayOfWeek?: DayOfWeek[];
  description?: string;
}

export interface TimeSpan extends Span {
  closes?: string;
  opens?: string;
}
